import React from 'react';

export type PrintStructuralBreakdownLine = {
  text: string;
  badge: string;
};

export type PrintStructuralBreakdownPayload = {
  title?: string;
  typography?: 'serif' | 'sans';
  lines?: PrintStructuralBreakdownLine[];
  explanation?: string;
  whyItMatters?: string;
};

/**
 * Vista impresa de desglose estructural — filas didácticas + prosa de enseñanza.
 */
export function PrintStructuralBreakdown({
  payload,
}: {
  payload: PrintStructuralBreakdownPayload;
}) {
  const isSerif = payload.typography !== 'sans';
  const lines = Array.isArray(payload.lines) ? payload.lines : [];
  const explanation = String(payload.explanation || '').trim();
  const whyItMatters = String(payload.whyItMatters || '').trim();

  return (
    <div className={`print-structural-breakdown${isSerif ? ' print-structural-breakdown--serif' : ''}`}>
      {payload.title ? (
        <h3 className="print-structural-breakdown__title">{payload.title}</h3>
      ) : null}
      {explanation ? (
        <p className="print-structural-breakdown__explanation">{explanation}</p>
      ) : null}
      {whyItMatters && whyItMatters !== explanation ? (
        <p className="print-structural-breakdown__why">{whyItMatters}</p>
      ) : null}
      <ul className="print-structural-breakdown__list">
        {lines.map((line, index) => (
          <li key={`${index}-${line.badge}`} className="print-structural-breakdown__row">
            <p className="print-structural-breakdown__text">{line.text}</p>
            {line.badge ? (
              <span className="print-structural-breakdown__badge">{line.badge}</span>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
